export default __webpack_public_path__ + "static/media/65.2b1d9e81.jpg";